<template>
  <div class="mb-3">
    <div class="navigation bg-blue">
      <header class="container mx-auto px-4 py-2">
        <div class="logo">
          <router-link :to="{ path: '/' }">
            <h1 class="text-header text-white">Ruminote</h1>
          </router-link>
        </div>
        <nav class="dr-nav">
          <div class="">
            <ul class="dr-menu">
<!--              <li>-->
<!--                <router-link-->
<!--                  :to="{ path: '/' }"-->
<!--                  class="hidden md:inline-block nav-link border-color-white"-->
<!--                >-->
<!--                  Home-->
<!--                </router-link>-->
<!--              </li>-->
<!--              <li>-->
<!--                <router-link-->
<!--                  :to="{ path: '/notes' }"-->
<!--                  class="hidden md:inline-block nav-link border-color-white"-->
<!--                >-->
<!--                  Discover-->
<!--                </router-link>-->
<!--              </li>-->
              <li v-if="!user">
                <router-link
                  :to="{ path: '/login' }"
                  class="md:inline-block nav-link border-color-white block mr-2"
                >
                  Login
                </router-link>
              </li>
              <li v-if="!user">
                <router-link
                  :to="{ path: '/register' }"
                  class="md:inline-block nav-link border-color-white block"
                >
                  Register
                </router-link>
              </li>
              <li class="text-white" v-if="user">
                <span v-on:click="displayOptions">
                  <Zondicon
                    class="nav-icon w-8 fill-current cursor-pointer"
                    icon="Menu"
                  />
                </span>
              </li>
            </ul>
          </div>
        </nav>
        <div style="clear: both;"></div>
        <popup
          @close="toggleLoginPopup"
          modalName="loginPopup"
          v-if="this.$store.state.notes.showLoginPopup"
        >
          <div slot="body"><login-popup></login-popup></div>
        </popup>
      </header>
    </div>
    <div v-if="showOptions" class="container mx-auto relative">
      <options-dropdown
          :closeMenu="
            closeOthers =>
              $store.dispatch('aShowOptions', { show: false, closeOthers })
          "
      >
      </options-dropdown>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import LoginPopup from "./LoginPopup.vue";
import Popup from "./ui/Popup.vue";
import OptionsDropdown from "./admin/OptionsDropdown";

export default {
  data() {
    return {
      mobileMenu: false
    };
  },

  computed: {
    user: function() {
      return this.$store.state.notes.user ? true : false;
    },
    showOptions() {
      return this.$store.state.notes.showOptions;
    }
  },

  components: {
    "login-popup": LoginPopup,
    Popup,
    OptionsDropdown,
  },

  methods: {
      displayOptions(e) {
          e.stopPropagation(); // stop outside click from closing dropdown
          this.$store.dispatch("aShowOptions", { show: !this.showOptions });
      },
    async logout() {
      this.$loading(true);
      await this.$store.dispatch("LOGOUT");
      this.$loading(false);
      this.$router.push({ path: "/login" });
    },
    toggleLoginPopup() {
      this.$store.dispatch("TOGGLE_LOGIN_POPUP");
    }
  }
};
</script>
<style lang="scss">
// .navigation {
//   background-color: #368ca8;
// }
.dr-nav {
  float: right;
}

.logo {
  float: left;
}

.logo .text-header {
  font-size: 1.7rem;
  text-shadow: 1px 1px 2px #000;
}

.logo a:hover {
  text-decoration: none;
}
.dr-menu {
  padding: 0;

  li {
    display: inline-block;
  }
}
.nav-link {
  @apply px-4 py-2 border text-white;
}
.nav-icon {
  top: 8px;
  position: relative;
  margin-top: -5px;
  margin-right: 8px;
}
</style>
